import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { createPinia } from 'pinia';
import piniaPersist from 'pinia-plugin-persist'
import CoreuiVue from '@coreui/vue'
import CIcon from '@coreui/icons-vue'
import SmartTable from 'vuejs-smart-table'
import { iconsSet as icons } from '@/assets/icons'
import DocsExample from '@/components/DocsExample'
import BackButton from '@/views/components/BackButton'
import Multiselect from '@vueform/multiselect'
import '@vueform/multiselect/themes/default.css'
import VueDatePicker from '@vuepic/vue-datepicker';
import './plugins/axios'
import '@vuepic/vue-datepicker/dist/main.css'
import './styles/styles.css'
import 'floating-vue/dist/style.css'
import 'sweetalert2/src/sweetalert2.scss'
import FloatingVue from 'floating-vue'

const pinia = createPinia()
pinia.use(piniaPersist)

const app = createApp(App)
app.use(FloatingVue)
app.use(pinia)
app.use(SmartTable)
app.use(store)
app.use(router)
app.use(CoreuiVue)
app.provide('icons', icons)
app.component('CIcon', CIcon)
app.component('DocsExample', DocsExample)
app.component('BackButton', BackButton)
app.component('Multiselect', Multiselect)
app.component('VueDatePicker', VueDatePicker);

app.mount('#app')
